import { Injectable } from '@angular/core';
import { LoggingService } from '@shared/logging';
import { LocalCredentialsModel, LocalCredentialsRepository } from '@database/central';
import { AccountModel } from '../models';
import { firstValueFrom, map } from 'rxjs';

@Injectable()
export class UserService {
	public constructor(
		private localCredentialsRepository: LocalCredentialsRepository,
		private loggingService: LoggingService
	) {}

	public async save(userData: AccountModel): Promise<void> {
		try {
			const userCredentials: LocalCredentialsModel = {
				...userData,
				failedAttempts: 0
			};

			await this.localCredentialsRepository.insertOrUpdate(userCredentials);
		} catch (error) {
			this.loggingService.error(error, '');
			throw new Error(error);
		}
	}

	public async getUserDetails(username: string): Promise<LocalCredentialsModel | null> {
		try {
			return await firstValueFrom(
				this.localCredentialsRepository
					.getByUsername$(username)
					.pipe(map((userDetails: LocalCredentialsModel | null) => userDetails))
			);
		} catch (error) {
			this.loggingService.error(error, '');
			throw new Error(error);
		}
	}
}
